// extracted by mini-css-extract-plugin
export default {"label":"label---clFG9","isEmptyMessage":"isEmptyMessage---OllOq"};